import { createFileRoute, useParams } from '@tanstack/react-router';

import { GbReportCardPrintPage } from '@/views/admin/gb-report-cards/gb-report-card-print.tsx';

// $id_ 再加一层下划线脱离详情路由（详情页无 <Outlet/>）的嵌套，让打印页在 /admin shell 下
// 独立全屏渲染（经 window.open 新标签打开）。URL 仍是 /admin/gb-report-cards/:id/print。
export const Route = createFileRoute('/admin/gb-report-cards_/$id_/print')({
  component: GbReportCardPrintRoute,
});

function GbReportCardPrintRoute() {
  const { id } = useParams({ from: '/admin/gb-report-cards_/$id_/print' });
  return <GbReportCardPrintPage id={id} />;
}
